export enum ContentType {
  Screen = 1,
  Image = 2,
  Video = 3,
  YouTube = 4,
  PDF = 5,
  Web = 6,
}
export enum ShowCaseType {
  All = -1,
  Tsusho = 2,
  Nyusho = 3
}

export enum DialogText {
  Create = 'コンテンツ区分を登録',
  Edit = 'コンテンツ区分を編集',
  CreateList = 'コンテンツを登録',
  EditList = 'コンテンツを編集',
  Required = '必要項目です。',
  FileTooLarge = 'ファイルサイズが大きすぎます。最大2GBまでアップロード可能です。',
  ThumbTooLarge = 'サムネイルファイルサイズが大きすぎます。最大2GBまでアップロード可能です。',
  UploadError = 'ファイルのアップロードに失敗しました。',
  FileSelect = 'クリックしてファイルを選択',
  ThumbSelect = 'クリックしてサムネイルを選択',
  // label
  Info = "基本情報",
  ItemCode = "コンテンツコード",
  ItemName = "コンテンツ名称",
  Description = "説明文",
  CategoryCode = "コンテンツ区分コード",
  DetailsContent = "コンテンツ詳細",
  CategoryName = "名称",
  SortNo = "No",
  Type = "種別",
  Path = "パス",
  Url = "URL",
  FileName = "ファイル名",
  Thumbnail = "サムネイル",
  ShowCase = "表示対象",
  PremiumOnly = "プレミアム専用",
  Screen = "システム",
  Image = "画像",
  Video = "動画",
  YouTube = "YouTube",
  PDF = "PDF",
  Web = "サイト",
  // ShowCaseLabel
  All = "全対象",
  Tsusho = "通所のみ",
  Nyusho = "入所のみ"
}
export enum CommonButton {
  Cancel = "キャンセル",
  Save = "保存",
  Add = "追加",
}
export enum TypeLabel {
  Screen = 'スクリーン',
  Image = '画像',
  Video = '動画',
  YouTube = 'YouTube',
  PDF = 'PDF',
  Web = 'Web'
}
export enum TypeIcon {
  Screen = 'screen.png',
  Image = 'img.png',
  Video = 'video.png',
  YouTube = 'youtube.png',
  PDF = 'pdf.png',
  Web = 'web.png'
}
export enum HeaderTableList {
  Index = 'No',
  Choice = "選択",
  Id = 'コンテンツコード',
  Name = 'コンテンツ名称',
  Description = '説明文',
  Type = '種別',
  ShowCase = '表示対象',
  Premium = 'プレミアム専用',
  Edit = '編集',
  Delete = '削除'
}
export enum HeaderTableCategory {
  Index = 'No',
  Id = 'コンテンツ区分コード',
  Name = 'コンテンツ区分名称',
  Description = '説明文',
  ContentCount = '項目',
  SortNo = 'No',
  Edit = '編集',
  Delete = '削除'
}
export enum Paginator {
  PageSize = '1ページの表示件数',
  TotalPage = '件中',
  RangePage = '件表示'
}